import React, { useState, useRef } from "react";
import { Steps, Button, message, Badge, Card, Form } from "antd";
import Question from "./Question";
import { LeftOutlined, RightOutlined, CheckOutlined } from "@ant-design/icons";
import { QuestionnaireContext } from "./QuestionnarieContext";
import styles from "./Questionnaire.css"; // Import the CSS file for styling
// const QuestionContext = React.createContext();

const Questionnaire = ({ questions, totalshowQuestion, onSave, clear }) => {
  //Set questions property answerSelecteds = [];
  questions.forEach((question) => {
    //set answerSelecteds = [] if answerSelecteds is undefined
    if (question.answerSelecteds === undefined) {
      question.answerSelecteds = [];
    }
  });
  const [questionsState, setQuestionsState] = useState(questions);
  const [currentStep, setCurrentStep] = useState(0);
  const totalQuestions = questions.length;
  //Use useRef to get the form instance
  const [form] = Form.useForm();

  const handleNext = () => {
    //Validate if all questions in the form was answered
    form
      .validateFields()
      .then((values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Por favor responda todas las preguntas");
          return;
        }
        setCurrentStep(currentStep + 1);
      })
      .catch((values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Por favor responda todas las preguntas");
          return;
        }
      });
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleFinish = () => {
    //From state questionsState we can get the answers selecteds with the question id like a new object
    let saveQuestionnaire = {
      questionnaireId: "",
      questions: [],
    };
    questionsState.forEach((question) => {
      //validate if answerSelecteds is array do nothing, else convert to array
      if (
        question.answerSelecteds != undefined &&
        !Array.isArray(question.answerSelecteds)
      ) {
        question.answerSelecteds = [question.answerSelecteds];
      }

      saveQuestionnaire.questions.push({
        questionId: question.question.key,
        answersSelecteds: question.answerSelecteds,
      });
    });
    onSave(saveQuestionnaire);
  };

  //TODO: Change using the context of react in the component Question

  const onChangeQuestion = (data) => {
    const questionIndex = questionsState.findIndex(
      (questionState) => questionState.question.key === data.question.key
    );
    if (questionIndex !== -1) {
      const newQuestions = [...questionsState];
      if (
        data.answers != undefined &&
        ((data.answers.value != undefined &&
          data.answers.value != null &&
          data.answers.value != "") ||
          (data.answers.text != undefined &&
            data.answers.text != null &&
            data.answers.text != "") ||
          (data.answers.options != undefined &&
            data.answers.options != null &&
            data.answers.options.length > 0))
      ) {
        newQuestions[questionIndex].answerSelecteds = data.answers;
        setQuestionsState(newQuestions);
      }
    }
  };

  //Group questions by section
  const questionsGroupBySection = questionsState.reduce((acc, question) => {
    if (acc[question.sectionName]) {
      acc[question.sectionName].push(question);
    } else {
      acc[question.sectionName] = [question];
    }
    return acc;
  }, {});

  const getStep = (key, title, children) => {
    return {
      key: key,
      title: title,
      children: children.map((data, questionIndex) => {
        const visible =
          data.parentQuestion !== undefined &&
          data.parentQuestion !== null &&
          data.question.key !== data.parentQuestion
            ? questionsState.filter((questions) => {
                if (questions.answerSelecteds !== undefined) {
                  var answer = questions.answers.filter(
                    (x) => x.id == questions.answerSelecteds.value
                  );
                  if (answer.length > 0) {
                    return (
                      questions.question.key === data.parentQuestion &&
                      answer[0].answer == "Sí"
                    );
                  }
                }
              }).length > 0
            : true;

        if (visible) {
          orderNumber++;
          return (
            <Question
              key={"question_step" + key + "_" + questionIndex}
              number={orderNumber}
              question={data.question}
              answers={data.answers}
              answerType={data.answerType}
            />
            // answerSelecteds={data.answerSelecteds}
          );
        }
        return null;
      }),
    };
  };

  let steps = [];
  let totalSteps = 0;
  let orderNumber = 0;
  if (Object.keys(questionsGroupBySection).length > 1) {
    steps = Object.keys(questionsGroupBySection).map((sectionName, index) => {
      const questions = questionsGroupBySection[sectionName];
      const start = index * totalshowQuestion;
      const end = start + totalshowQuestion;
      const stepQuestions =
        Object.keys(questionsGroupBySection).length == 1
          ? questions.slice(start, end)
          : questions;
      return getStep("section_" + index, sectionName, stepQuestions);
    });
    totalSteps = steps.length;
  } else {
    totalSteps = Math.ceil(totalQuestions / totalshowQuestion);
    steps = Array.from({ length: totalSteps }, (_, index) => {
      const start = index * totalshowQuestion;
      const end = start + totalshowQuestion;
      const stepQuestions = questionsState.slice(start, end);
      return getStep("section_" + index, `Sección ${index + 1}`, stepQuestions);
    });
  }
  return (
    <div>
      <div className="row">
        <div className="col-md-2">
          <Steps
            direction="vertical"
            current={currentStep}
            items={steps}
            style={{ overflow: "auto", fontSize: "12px" }}
          />
        </div>
        <div className="col-md-9">
          <div className="steps-content">
            <QuestionnaireContext.Provider
              value={{ questionsState, onChangeQuestion, clear }}
            >
              <Badge.Ribbon
                text={
                  steps[currentStep] != undefined
                    ? steps[currentStep].title
                    : ""
                }
                color="blue"
              >
                <Card title="">
                  <Form form={form}>{steps[currentStep]?.children}</Form>
                </Card>
              </Badge.Ribbon>
            </QuestionnaireContext.Provider>
          </div>
        </div>
      </div>
      <div className="steps-action mt-4">
        {currentStep > 0 && (
          <Button style={{ margin: "0 8px" }} onClick={handlePrevious}>
            <LeftOutlined />
            Anterior
          </Button>
        )}
        {currentStep < totalSteps - 1 && (
          <Button type="primary" onClick={handleNext}>
            Siguiente
            <RightOutlined />
          </Button>
        )}
        {currentStep === totalSteps - 1 && (
          <Button type="primary" onClick={handleFinish}>
            Finalizar
            <CheckOutlined />
          </Button>
        )}
      </div>
    </div>
  );
};

export default Questionnaire;
